/* State module specific to the boilerplate. Typically, there is no need to change this. */

// App module store contains all states that manage application
import locale from 'locale2';

// Mutations and Actions
import { ROUTE_MODULE } from '@/store/modules/routeModule';
import mutations from './mutations';
import actions from './actions';

const boilerplate = {
  namespaced: true,
  state: {
    sidebar: {
      opened: false,
      right: {
        opened: false,
      },
    },
    modal: {
      isOpen: [],
      isFullscreen: false,
      initialTab: null,
    },
    language: locale.split('-')[0] || 'fr',
    authenticated: true,
    token: null,
    init: false,
    isLoading: null,
    delayedModules: [],
    darkThemeEnabled: false,
    scrollOffNavbarEnabled: false,
  },
  getters: {
    sidebar: (state) => state.sidebar,
    isOpen: (state) => state.modal.isOpen || [],
    isOpenOnRoutes: (state, getters) =>
      getters.isOpen.map((item) => item.route),
    isInit: (state) => state.init,
    isLoading: (state) => state.isLoading,
    delayedModules: (state) => state.delayedModules,
    isModalOpen: (state, getters, rootState) =>
      getters.isOpenOnRoutes.includes(rootState[ROUTE_MODULE].name),
    isModalFullscreen: (state) => state.modal.isFullscreen,
    modalInitialTab: (state) => state.modal.initialTab,
    rightSidebar: (state) => state.sidebar.right,
    language: (state) => state.language,
    authenticated: (state) => state.authenticated,
    darkThemeEnabled: (state) => state.darkThemeEnabled,
    scrollOffNavbarEnabled: (state) => state.scrollOffNavbarEnabled,
  },
  mutations,
  actions,
};

export default boilerplate;
